import React from "react";

const badgeColors = {
  "Top 10%": "#2b6cb0",
  "Top 25%": "#d69e2e",
  "Above Average": "#4a5568",
  "Below Average": "#c53030",
  "Top 10% (younger)": "#2b6cb0",
  "Top 25% (younger)": "#d69e2e",
  "Above Average (younger)": "#4a5568",
  "Older than average": "#c53030"
};

export default function RankReport({ scores }) {
  return (
    <div style={{ marginTop: 40 }}>
      <h2 style={{ fontSize: 24, marginBottom: 20 }}>Your Dating Market Scorecard</h2>
      {Object.entries(scores).map(([trait, rank]) => (
        <div
          key={trait}
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "12px 16px",
            marginBottom: 10,
            background: "#f7fafc",
            borderRadius: 6,
            borderLeft: `6px solid ${badgeColors[rank] || "#999"}`
          }}
        >
          <strong style={{ textTransform: "capitalize" }}>{trait}</strong>
          <span
            style={{
              backgroundColor: badgeColors[rank] || "#999",
              color: "white",
              padding: "4px 12px",
              borderRadius: "12px",
              fontWeight: "bold",
              fontSize: 14
            }}
          >
            {rank}
          </span>
        </div>
      ))}
    </div>
  );
}
